export default __webpack_public_path__ + "assets/images/platforms/db7af55475871e4301819ba3dc440060.png";